module.exports = __webpack_public_path__ + "static/divider14-0987317ac20a44c34a39c3e6931d7bba.svg";